import { ContentItem } from '@deltek/specification-client/core/Models/contentItem'
import { RemoveProjectContentInput } from '@deltek/specification-client/core/Models/projectProductProperty'
import React from 'react'
import { NormalizedDocumentTemplateViewItem } from './model'

export interface TabsContextValue {
    haveProducts?: boolean
    handleUpdateTemplate?: (
        value: NormalizedDocumentTemplateViewItem,
        retrieveChanges?: boolean,
        contentItemNodes?: Partial<ContentItem>[]
    ) => void
    handleUpdateTemplates?: (
        value: NormalizedDocumentTemplateViewItem[]
    ) => void
    handleUpdateTemplateContentItems?: (contentItems: ContentItem[]) => void
    dragStarted?: boolean
    setDragStarted?: (value?: boolean) => void
    removeProperty?: (
        removeProjectContentItem: Partial<RemoveProjectContentInput>,
        isArticle?: boolean
    ) => void
    getUpdatedNugget?: (
        isDTVToBeRetrieved: boolean,
        isDrawingTagUpdated?: boolean,
        isSelectedFromListingDialog?: boolean
    ) => void
}

export const TabsContext = React.createContext({} as TabsContextValue)

export interface TabsProviderProps {
    haveProducts?: boolean
    handleUpdateTemplate?: (
        value: NormalizedDocumentTemplateViewItem,
        retrieveChanges?: boolean,
        contentItemNodes?: Partial<ContentItem>[]
    ) => void
    handleUpdateTemplates?: (
        value: NormalizedDocumentTemplateViewItem[]
    ) => void
    handleUpdateTemplateContentItems?: (contentItems: ContentItem[]) => void
    removeProperty?: (
        removeProjectContentItem: Partial<RemoveProjectContentInput>,
        isArticle?: boolean
    ) => void
    getUpdatedNugget?: (
        isDTVToBeRetrieved: boolean,
        isDrawingTagUpdated?: boolean,
        isSelectedFromListingDialog?: boolean
    ) => void
}

export const TabsProvider: React.FC<TabsProviderProps> = ({
    haveProducts,
    children,
    handleUpdateTemplate,
    handleUpdateTemplates,
    handleUpdateTemplateContentItems,
    removeProperty,
    getUpdatedNugget,
}) => {
    const [dragStarted, setDragStarted] = React.useState<boolean>()

    return (
        <TabsContext.Provider
            value={{
                haveProducts,
                dragStarted,
                setDragStarted,
                handleUpdateTemplate,
                handleUpdateTemplates,
                handleUpdateTemplateContentItems,
                removeProperty,
                getUpdatedNugget,
            }}
        >
            {children}
        </TabsContext.Provider>
    )
}
